import React__default from 'react';
import { u as useTaktId, T as TaktIdProvider } from '../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';

const TaktWrapper = ({
  taktId,
  children
}) => {
  const {
    dataTaktFeature
  } = useTaktId({});
  if (!dataTaktFeature) {
    return /*#__PURE__*/React__default.createElement(TaktIdProvider, {
      taktId: taktId
    }, children);
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children);
};

export { TaktWrapper as T };
//# sourceMappingURL=TaktWrapper-D0n9LpMr.js.map
